module.exports = __webpack_public_path__ + "static/media/openclipart.b424de61.png";